<template>
  <div class="card bd-gray-400">
    <table class="table mg-b-0 bill table-contact data-table">
      <thead>
        <tr>
          <th class="tx-10-force tx-mont tx-medium">
            <label class="ckbox mg-b-0 d-inline-block valign-middle mg-r-10">
              <input
                type="checkbox"
                :checked="isAll"
                @change="changeAllCheck($event)"
              /><span></span>
            </label>
            {{ $t("order.登录用户名") }}
          </th>
          <th class="wd-200 tx-10-force tx-mont tx-medium hidden-xs-down">
            {{ $t("subuser.姓名 / 角色组") }}
          </th>
          <th class="tx-10-force tx-mont tx-medium hidden-xs-down">
            {{ $t("mall.联系方式") }}
          </th>
          <th class="wd-100 tx-10-force tx-mont tx-medium hidden-xs-down">
            {{ $t("mall.状态") }}
          </th>
          <th class="tx-10-force tx-mont tx-medium hidden-xs-down">
            {{ $t("express.最近登录时间") }}
          </th>
          <th class="tx-10-force tx-mont tx-medium tx-center hidden-xs-down">
            {{ $t("subuser.操作") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="valign-middle">
            <div class="d-flex align-items-center">
              <label class="ckbox mg-b-0 d-inline-block valign-middle mg-r-10">
                <input
                  type="checkbox"
                  :value="item.id"
                  v-model="checkArr"
                /><span></span>
              </label>
              <!-- 头像 -->
              <div
                v-if="item.headImg"
                class="text-user-icon wx"
                :style="{ backgroundImage: `url(${item.headImg})` }"
              ></div>
              <!-- 以用户名做头像 -->
              <div
                v-else
                class="text-user-icon"
                v-text="item.username.substr(0, 1).toUpperCase()"
                :style="{ background: textColor(item.username) }"
              ></div>
              <div class="mg-l-15">
                <div class="tx-white" v-text="item.username"></div>
                <!-- 是否绑定微信公众号 -->
                <div v-if="item.wxOpenId">
                  <span class="tx-success"
                    ><i class="fa fa-weixin mg-r-10"></i
                    >{{ $t("subuser.已绑定微信公众号") }}</span
                  >
                </div>
                <div v-else>
                  <span>{{
                    $t("subuser.暂未授权微信服务号，登录后可授权")
                  }}</span>
                </div>
              </div>
            </div>
          </td>
          <td class="valign-middle hidden-xs-down">
            <div class="tx-white" v-text="item.name"></div>
            <div v-text="item.roleName"></div>
          </td>
          <td class="valign-middle hidden-xs-down">
            <div>
              {{ $t("mall.手机：")
              }}<span class="tx-white">{{
                item.mobile ? item.mobile : "---"
              }}</span>
            </div>
            <div>
              {{ $t("distributor.邮箱：")
              }}<span class="tx-white">{{
                item.email ? item.email : "---"
              }}</span>
            </div>
            <div v-if="item.qq">
              QQ:<a
                :href="
                  'tencent://message/?uin=' + item.qq + '&Site=5yoho&Menu=yes'
                "
                class="qq-link tx-info"
                >{{ item.qq }}</a
              >
            </div>
          </td>
          <td class="valign-middle hidden-xs-down">
            <div class="tx-white">
              {{ item.status == 1 ? $t("mall.启用") : $t("mall.停用") }}
            </div>
          </td>
          <td class="valign-middle tx-12">
            <span class="tx-white">{{
              item.timeLogin ? item.timeLogin : "---"
            }}</span>
          </td>
          <td class="valign-middle tx-12">
            <div>
              <a
                v-if="isSysRights('SubUser.changeByUser')"
                class="tx-info btn-sm tx-12"
                href="javascript:;"
                @click="editSubUser(item)"
                >{{ $t("order.编辑") }}</a
              >
            </div>
            <div v-if="!$root.$children[0].userInfo.rootUrl">
              <a
                v-if="item.wxOpenId"
                class="btn-sm tx-12 tx-info"
                href="javascript:;"
                @click="subUserUnBindWx(item)"
                >{{ $t("subuser.解除微信登录") }}</a
              >
              <a
                v-else
                class="btn-sm tx-12 tx-info"
                href="javascript:;"
                @click="subUserBindWx(item)"
                >{{ $t("subuser.绑定微信登录") }}</a
              >
            </div>
            <div>
              <a
                v-if="isSysRights('Relationship.updateSubUserId')"
                href="javascript:;"
                class="btn-sm tx-12 tx-info"
                @click="relationship(item)"
              >
                {{ $t("subuser.关联客户") }}
              </a>
            </div>
            <div>
              <a
                v-if="isSysRights('SubUser.deleteByUser')"
                href="javascript:;"
                class="btn-sm tx-12 tx-info"
                @click="delSubUserBySupplier(item)"
                >{{ $t("subuser.删除") }}</a
              >
            </div>
          </td>
        </tr>
        <tr v-if="(!items || items.length < 1) && !first_loading">
          <td colspan="4">
            <div class="col-12 none-product">
              <i class="fa fa-ban"></i>{{ $t("subuser.没有符合条件的子账号") }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "check_arr"],
  data() {
    return {
      checkArr: [],
    };
  },
  computed: {
    isAll() {
      const items = this.items || [];
      return this.checkArr.length == items.length && items.length > 0
        ? true
        : false;
    },
  },
  watch: {
    check_arr() {
      this.checkArr = this.check_arr;
    },
    checkArr() {
      this.$parent.checkArr = this.checkArr;
    },
  },
  methods: {
    // 全选或者全不选
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
    // 关联客户
    relationship(item) {
      this.$emit("relationship", item);
    },
    textColor(txt) {
      return computColor(txt);
    },
    // 编辑子账号信息
    editSubUser(item) {
      this.$parent.subUserinfo = item;
      $("#modalAddSubUserBySupplier").modal("show");
    },
    // 删除子账号
    delSubUserBySupplier(item) {
      this.$parent.subUserinfo = {};
      this.$parent.subUserinfo = {
        delId: item.id,
        delName: item.name,
      };
      $("#modalDelSubUserBySupplier").modal("show");
    },
    // 绑定微信登录
    subUserBindWx(item) {
      this.$parent.subUserinfo = {};
      this.$parent.subUserinfo = {
        open: Symbol(),
        subuserId: item.id,
      };
      $("#modalWchatTaskSubuserBySupplier").modal("show");
    },
    // 解除微信登录
    subUserUnBindWx(item) {
      this.$parent.subUserinfo = item;
      $("#modalSubuserUnbindWxBySupplier").modal("show");
    },
  },
};
</script>